<template>
  <div>
    <b-card title="Görsel">
      <b-img
          v-if="dataItem.image"
          :src="imageUrl + '/media/products/' + dataItem.image"
          thumbnail
          center
      />
      <div class="text-center mt-1">
        <b-button
            variant="primary"
            @click="setModal('productsItems',cropperSettings.fileName)"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yükle
        </b-button>
      </div>
    </b-card>
    <cropper-image
        v-if="cropperSettings.type"
        :modal-status="cropperSettings.modalStatus"
        :close-modal="closeModal"
        :file-name="cropperSettings.fileName"
        :folder="cropperSettings.folder"
        :ratio="cropperSettings.ratio"
        :width-size="cropperSettings.widthSize"
        component="productsItems"
        :params="cropperSettings.type"
        :item-id="dataItem.id"
        @uploadImage="setUploadImage"
    />
  </div>
</template>
<script>
import { BCard, BImg, BButton } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'ImageCardWebp',
  components: {
    BCard,
    BImg,
    BButton,
    CropperImage,
  },
  data() {
    return {
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      },
      required,
      imageUrl: this.$store.state.app.baseURL,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['productsItems/dataItem']
    },
  },
  methods: {
    setModal(type, file) {
      const fileNamee = file?.name
      if (type === 'productsItems') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: fileNamee,
          folder: 'products',
          ratio: 334 / 170,
          widthSize: 334,
          type: 'productsItems',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      this.dataItem.image = item.filename
      this.dataItem.thumb = item.thumb
      this.dataItem.image_webp = item.filename_webp
      this.dataItem.thumb_webp = item.thumb_webp
      this.dataItem.mediaData = item
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
